export const referenceEditorSections = [["overview","Temel bilgiler"],["content","Detay içeriği"],["metrics","Metrikler"],["video","Video"],["relations","Sektör ve hizmetler"],["seo","SEO"],["preview","Önizleme"]];
